<template lang="html">
  <div class="form-floating dropdown-wrapper">
    <div class="dropdown" :class="{ 'is-active': active }">
      <div class="dropdown-trigger" @click="trigger" style="min-width: 8vw">
        <div class="dropdown-select-wrapper">
          <label class="floating-label" :class="{ 'shrink': selectedItem[itemKey] || active }">
            {{ defaultLabel }}
          </label>
          <div class="selected-label">
  <span
      class="ms-3 d-inline-block text-truncate"
      style="max-width: 100%;"
      v-if="selectedItem[itemKey]"
  >
    {{ selectedItem[itemKey] }}
  </span>
          </div>
          <i
              class="fa fa-times clear-icon"
              v-if="selectedItem[itemKey] != null"
              @click.stop.prevent="clear"
          ></i>
          <i class="fa fa-chevron-down dropdown-icon"></i>
        </div>
      </div>

      <div class="dropdown-menu" role="menu">
        <div class="dropdown-content p-2">
          <input
              v-if="itemsList && itemsList.length !== 0 && showSearchField"
              v-model="filter"
              class="search-input input"
              type="text"
              ref="searchField"
              placeholder="Rechercher…"
          />
          <div class="sub-item-list">
            <a
                v-if="itemsList"
                v-for="item in filteredItemsList"
                :key="item[itemKey]"
                @click="selectedItem = item; active = false;"
                href="#"
                class="dropdown-item"
                :class="{ 'is-active': selectedItem === item }"
            >
              {{ item[itemKey] }}
            </a>
          </div>
          <span class="has-text-grey" v-if="!itemsList || itemsList.length === 0">
            Cette liste est vide
          </span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "DropDownSearch",
  props: {
    items: false,
    showSearchField: false,
    currentValue: Object,
    defaultLabel: String,
    shownKey: String,
    customClasses: String
  },
  data() {
    return {
      filter: "",
      itemsList: [],
      active: false,
      selectedItem: this.currentValue || {}
    };
  },
  computed: {
    itemKey() {
      return !this.shownKey ? "name" : this.shownKey;
    },
    filteredItemsList() {
      if (this.itemsList) {
        return this.itemsList.filter(item => {
          if (!item[this.itemKey]) return false;
          return item[this.itemKey].toLowerCase().indexOf(this.filter.toLowerCase()) >= 0;
        });
      }
      return [];
    }
  },
  methods: {
    trigger(e) {
      if (e.target.id === "clear-selected") {
        this.active = false;
      } else {
        this.active = !this.active;
        if (this.active && this.showSearchField) {
          this.$nextTick(() => this.$refs.searchField.focus());
        }
      }
    },
    clear(e) {
      this.selectedItem = null;
      e.preventDefault();
    },
    click() {
      this.active = !this.active;
    },
    closeListener(e) {
      if (!this.$el.contains(e.target)) {
        this.active = false;
      }
    }
  },
  async mounted() {
    if (this.items) {
      this.itemsList = await this.items;
    }
    document.addEventListener("click", this.closeListener, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeListener, true);
  },
  watch: {
    items(newVal) {
      if (newVal) {
        this.itemsList = newVal;
      }
    },
    currentValue(newVal) {
      this.selectedItem = newVal;
    },
    selectedItem(newVal) {
      this.$emit("dropdownClick", newVal);
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.dropdown {
  min-width: 5vw;
  max-width: 8vw;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  vertical-align: top;
}

.dropdown-wrapper {
  min-width: 5vw;
  position: relative;
  font-family: 'Segoe UI', sans-serif;
}

.dropdown-select-wrapper {
  position: relative;
  display: flex;
  height: 2.8em;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  padding: 10px 5px;
}

.floating-label {
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
  font-size: 1rem;
  color: #aaa;
  transition: all 0.2s ease-out;
  pointer-events: none;
}

.floating-label.shrink {
  top: 6px;
  font-size: 0.75rem;
}

.selected-label {
  flex-grow: 1;
  overflow: hidden;
}

.selected-label span {
  margin-top: 1vh;
  display: inline-block;
  max-width: 5vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.placeholder {
  color: #bbb;
}

.clear-icon,
.dropdown-icon {
  font-size: 0.9rem;
  color: #999;
  margin-left: 8px;
}

.clear-icon {
  cursor: pointer;
}

.dropdown-icon {
  margin-right: 4px;
}

.search-input {
  width: 100%;
  margin-bottom: 8px;
  padding: 0.5rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.95rem;
}

.dropdown-item {
  padding: 0.4rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background: #f0f0f0;
}

.dropdown-item.is-active {
  background-color: #e8f0fe;
  color: #1a73e8;
}

.sub-item-list {
  max-height: 250px;
  overflow-y: auto;
}

.dropdown-menu {
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 4px;
  background: white;
}

</style>
